import 'antd-mobile/dist/antd-mobile.css';
import React, { Component, useState } from 'react';
// import ReactDOM from 'react-dom';
// import { MobilePDFReader  } from 'react-read-pdf';
// import { Document, Page } from "react-pdf";
// import myPdf from './N2.pdf'
// import header from "../../images/N2_lite_manual/header.jpg"
import N2_lite_header from "../../images/N2_lite_manual/header.png"
import N2_lite_en from "../../images/N2_lite_manual/en.png"
import N2_lite_vn from "../../images/N2_lite_manual/vn.png"
import N2_lite_pt from "../../images/N2_lite_manual/pt.png"
import N2_lite_tr from "../../images/N2_lite_manual/tr.png"

import N2_header from "../../images/N2_manual/header.jpg"
import N2_en from "../../images/N2_manual/en.jpg"
import N2_fr from "../../images/N2_manual/fr.jpg"
import N2_de from "../../images/N2_manual/de.jpg"
import N2_jp from "../../images/N2_manual/jp.jpg"
import N2_cn from "../../images/N2_manual/cn.jpg"

import Q11_header from "../../images/Q11_manual/header.jpg"
import Q11_en from "../../images/Q11_manual/en.jpg"
import Q11_fr from "../../images/Q11_manual/fr.jpg"
import Q11_de from "../../images/Q11_manual/de.jpg"
import Q11_jp from "../../images/Q11_manual/jp.jpg"
import Q11_cn from "../../images/Q11_manual/cn.jpg"

import S5C_header from "../../images/S5C_manual/header.jpg"
import S5C_en from "../../images/S5C_manual/en.jpg"
import S5C_fr from "../../images/S5C_manual/fr.jpg"
import S5C_de from "../../images/S5C_manual/de.jpg"
import S5C_jp from "../../images/S5C_manual/jp.jpg"
import S5C_cn from "../../images/S5C_manual/cn.jpg"
import S5C_cn1 from "../../images/S5C_manual/cn1.jpg"

import Korea_manual from "../../images/Korea_manual/korea_manual.jpg"

import intl from 'react-intl-universal';
// import CN1 from "../../images/N2_lite_manual/cn1.jpg"
// import { pdfjs } from 'react-pdf';
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;



// const pdfFile = myPdf


class Pdf extends Component {
    render() {

        // var lang = (navigator.systemLanguage ? navigator.systemLanguage : navigator.language);
        // var nav = navigator
        const urlParams = new URL(window.location.href);
        const pathname = urlParams?.pathname;
        const arr = pathname.split("/");
        const path = arr[1];



        // console.log(nav);
        // alert(langs);


        if (path == "s5c") {
            return (
                <div>
                    <img style={{ width: '100%' }} src={S5C_header}></img>
                    <img style={{ width: '100%' }} src={S5C_en}></img>
                    <img style={{ width: '100%' }} src={S5C_fr}></img>
                    <img style={{ width: '100%' }} src={S5C_de}></img>
                    <img style={{ width: '100%' }} src={S5C_jp}></img>
                    <img style={{ width: '100%' }} src={S5C_cn}></img>
                    <img style={{ width: '100%' }} src={S5C_cn1}></img>
                </div>
            );
        } else if (path == "Q11") {
            if(navigator.language == "ko" || navigator.browserLanguage == "ko" || navigator.systemLanguage == "ko" || navigator.userLanguage == "ko"){
                return (
                    <div>
                        <img style={{ width: '100%' }} src={Korea_manual}></img>
                    </div>
                );
            }
            // if (lang == "ko") {
            //     return (
            //         <div>
            //             <img style={{ width: '100%' }} src={Korea_manual}></img>
            //         </div>
            //     );
            else {
                return (
                    <div>
                        <img style={{ width: '100%' }} src={Q11_header}></img>
                        <img style={{ width: '100%' }} src={Q11_en}></img>
                        <img style={{ width: '100%' }} src={Q11_fr}></img>
                        <img style={{ width: '100%' }} src={Q11_de}></img>
                        <img style={{ width: '100%' }} src={Q11_jp}></img>
                        <img style={{ width: '100%' }} src={Q11_cn}></img>
                    </div>
                );
            }
        } else if (path == "N2") {
            return (
                <div>
                    <img style={{ width: '100%' }} src={N2_header}></img>
                    <img style={{ width: '100%' }} src={N2_en}></img>
                    <img style={{ width: '100%' }} src={N2_fr}></img>
                    <img style={{ width: '100%' }} src={N2_de}></img>
                    <img style={{ width: '100%' }} src={N2_jp}></img>
                    <img style={{ width: '100%' }} src={N2_cn}></img>
                </div>
            );
        } else if (path == "N2-lite") {
            return (
                <div>
                    <img style={{ width: '100%' }} src={N2_lite_header}></img>
                    <img style={{ width: '100%' }} src={N2_lite_en}></img>
                    <img style={{ width: '100%' }} src={N2_lite_vn}></img>
                    <img style={{ width: '100%' }} src={N2_lite_tr}></img>
                    <img style={{ width: '100%' }} src={N2_lite_pt}></img>
                </div>
            );
        }

    }
}

// class Pdf extends Component {
//     state = {
//         numPages: null,
//         pageNumber: 1,
//     }

//     onDocumentLoadSuccess = ({ numPages }) => {
//         this.setState({ numPages });
//     }
//     render() {

//         const { pageNumber, numPages } = this.state;
//         var clientWidth = window.screen.width;
//         var scale=(clientWidth/552).toFixed(2)
//         return (
//                 <div>
//                     <Document file={pdfFile}  onLoadSuccess={this.onDocumentLoadSuccess} loading="">
//                             {
//                                 new Array(numPages).fill('').map((item, index) => {  
//                                     return <Page key={index+1} pageNumber={index+1}  scale={scale} />
//                                 })
//                             }
//                     </Document>
//                  </div>
//         );
//     }
// }




export default Pdf

